<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/categorias">Categorias de Notícias</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Categoria </a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">
                Cadastrar Categoria
              </h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label>Titulo</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo"
            placeholder="Insira o titulo da categoria"
          />
        </div>

        <div class="col-6">
          <label>Url</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo_url"
            placeholder="Insira a url da categoria"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="col-9 mt-4 pt-2">
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="button"
            @click="salvarCategoria()"
          >
            Cadastrar
          </button>

          <button
            class="btn btn_voltar btn-secondary float-end me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'categorias' })"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      id: "",
      titulo: "",
      titulo_url: "",
      status: "ATIVO",
    });

    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchCategoria();
      }
    });

    async function fetchCategoria() {
      try {
        const { data } = await services.categoria.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.titulo = data.titulo;
        state.titulo_url = data.titulo_url;
        state.status = data.status;
      } catch (error) {
        console.log(error);
      }
    }

    async function salvarCategoria() {
      let dados = {
        titulo: state.titulo,
        titulo_url: state.titulo_url,
        status: state.status,
        token,
      };
      if (!state.id) {
        try {
          await services.categoria.save(dados, token);
          router.push({ name: "categorias" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.id = state.id;
        try {
          await services.categoria.update({ dados, token });
          router.push({ name: "categorias" });
        } catch (error) {
          console.log(error);
        }
      }
    }

    return {
      salvarCategoria,
      router,
      state,
    };
  },
};
</script> 
<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}
.card {
  min-height: 94.8vh;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>